var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import $request from '../../utils/request';
import axios from '@didi/dajax';
var state = {
    vehicleDetail: {},
    showVehicleCheckDialog: false,
    showVehicleEditDialog: false,
    searchList: [],
    vehicleList: [],
    noOptions: false,
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    GET_VEHICLE_DETAIL_INFO: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 获取车辆详情
        var type = params.type;
        delete params.type;
        $request({
            method: 'post',
            url: '/proxy/vehicle/driver/vehicle/detail',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res)
                return;
            if (res && !res.errorCode) {
                commit('update', {
                    vehicleDetail: res.data,
                    showVehicleCheckDialog: type === 'check' ? true : false,
                    showVehicleEditDialog: type === 'edit' ? true : false,
                });
            }
        });
    },
    GET_DRIVEROPERATOR_LIST: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 获取经办人列表 车辆型号 车牌号 公司提示 司机姓名提示
        commit('update', {
            searchList: [],
        });
        axios({
            method: 'post',
            url: '/proxy/vehicle/driver/search/hint',
            needEncrypt: true,
            data: __assign({}, params),
        }).then(function (res) {
            if (!res)
                return;
            var result = res.data;
            if (result && !result.errorCode) {
                var array_1 = [];
                if (!result.data.length) {
                    commit('update', {
                        noOptions: true,
                    });
                }
                else {
                    commit('update', {
                        noOptions: false,
                    });
                }
                if (result.data.length) {
                    result.data.forEach(function (item) {
                        var obj = {
                            val: '',
                        };
                        obj.val = item;
                        obj.label = item;
                        array_1.push(obj);
                    });
                    commit('update', {
                        searchList: array_1,
                    });
                }
            }
        });
    },
    GET_VEHICLE_LIST: function (_a, params) {
        var commit = _a.commit;
        $request({
            method: 'post',
            url: '/proxy/vehicle/driver/vehicle/search',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res)
                return;
            if (res && !res.errorCode) {
                commit('update', {
                    vehicleList: res,
                });
            }
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
